import * as Yup from "yup";
import urlRegex from "~/lib/utils/urlRegex";
import useIntlValidationMessages from "~/lib/hooks/useIntlValidationMessages";

export default (intlValidationMessages: ReturnType<typeof useIntlValidationMessages>) =>
  Yup.object({
    name: Yup.string()
      .transform(ensureFilledString)
      .required(intlValidationMessages.cantBeBlank),
    billingName: Yup.string().nullable(),
    description: Yup.string()
      .transform(ensureFilledString)
      .required(intlValidationMessages.cantBeBlank),
    yearFounded: Yup.number()
      .required(intlValidationMessages.cantBeBlank)
      .min(1500, intlValidationMessages.invalidYear)
      .max(new Date().getFullYear(), intlValidationMessages.invalidYear),
    site: Yup.string()
      .transform(ensureFilledString)
      .required(intlValidationMessages.cantBeBlank)
      .matches(urlRegex, intlValidationMessages.invalidUrl),
    contact: Yup.string().test({
      message: intlValidationMessages.invalidEmailAddress,
      test: value => {
        if (!value) {
          return true;
        }

        const urlSchema = Yup.string().matches(urlRegex);
        const emailSchema = Yup.string().email();

        let validUrl;
        let validEmail;

        try {
          urlSchema.validateSync(value);

          validUrl = true;
        } catch (e) {
          validUrl = false;
        }

        try {
          emailSchema.validateSync(value);

          validEmail = true;
        } catch (e) {
          validEmail = false;
        }

        return validEmail || validUrl;
      },
    }),
    socialMedia: Yup.object({
      linkedin: Yup.string()
        .url(intlValidationMessages.invalidUrl)
        .nullable(),
      twitter: Yup.string()
        .url(intlValidationMessages.invalidUrl)
        .nullable(),
      facebook: Yup.string()
        .url(intlValidationMessages.invalidUrl)
        .nullable(),
      instagram: Yup.string()
        .url(intlValidationMessages.invalidUrl)
        .nullable(),
      youtube: Yup.string()
        .url(intlValidationMessages.invalidUrl)
        .nullable(),
    }).nullable(),
  });

function ensureFilledString(maybeFilled: string | null): string | null {
  if (!maybeFilled) {
    return "";
  }

  if (maybeFilled.trim().length === 0) {
    return "";
  }

  return maybeFilled;
}
